import { MatSnackBarConfig } from "@angular/material/snack-bar";

export const WarningDefaultOptions: MatSnackBarConfig = {
  panelClass: ['warning-snackbar'],
  horizontalPosition: 'right',
  verticalPosition: 'top',
  duration: 5000,
}